(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["escapein-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll(".escapein-reviews").forEach(section => {
    const wrapper = section.querySelector(".reviews-wrapper");
    const left = section.querySelector(".arrow-left");
    const right = section.querySelector(".arrow-right");

    if (left && right && wrapper) {
      left.addEventListener("click", () => {
        wrapper.scrollBy({ left: -wrapper.offsetWidth, behavior: "smooth" });
      });
      right.addEventListener("click", () => {
        wrapper.scrollBy({ left: wrapper.offsetWidth, behavior: "smooth" });
      });
    }

    section.querySelectorAll(".review-card.video").forEach(card => {
      const videoId = card.dataset.videoId;
      const thumb = card.querySelector(".video-thumbnail");

      if (thumb) {
        thumb.addEventListener("click", () => {
          card.innerHTML = `
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/${videoId}?autoplay=1" frameborder="0" allowfullscreen></iframe>
            <p class="author">${card.dataset.author || ""}</p>
          `;
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
// Aqui vai o JS

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  const handleParallax = () => {
    if (window.innerWidth < 768) return; // desativa no mobile

    document.querySelectorAll(".how-it-works").forEach(section => {
      const up = section.querySelector('[data-parallax="up"]');
      const down = section.querySelector('[data-parallax="down"]');
      const offset = window.scrollY * 0.1;

      if (up) up.style.transform = `translateY(-${offset}px)`;
      if (down) down.style.transform = `translateY(${offset}px)`;
    });
  };

  window.addEventListener('scroll', handleParallax);
  window.addEventListener('resize', handleParallax); // recalc ao redimensionar

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll(".product-carousel").forEach((carouselSection) => {
  const carousel = carouselSection.querySelector(".products-wrapper");
  const left = carouselSection.querySelector(".arrow-left");
  const right = carouselSection.querySelector(".arrow-right");

  if (carousel && left && right) {
    left.addEventListener("click", () => {
      carousel.scrollBy({ left: -carousel.offsetWidth, behavior: "smooth" });
    });

    right.addEventListener("click", () => {
      carousel.scrollBy({ left: carousel.offsetWidth, behavior: "smooth" });
    });
  }
});
1

  } catch(e) { console.error(e); }
})();
})();
